import { game } from '../main';
import { lerp } from '../utils/lerp';
import { OneLineText, createOneLineText } from '../Components/OneLineText';
import { makeImage } from '../utils/makeImage';
import { playSound } from '../handlers/playSound';
import { WindowLayer } from './WindowLayer';
import { PopupHelp } from './PopupHelp';
import { PopupSetup } from './PopupSetup';

export class SettingsMenu extends Phaser.Group {
  private readonly desktop: boolean;
  public open: boolean = false;
  private bg: Phaser.Image;

  constructor(
    desktop: boolean,
    windowLayer: WindowLayer,
  ) {
    super(game);
    this.desktop = desktop;
    if (!desktop) this.y = -10;

    this.bg = makeImage(0, 0, 'settings_menue', 0, this);
    if (!desktop) this.bg.scale.y = -1;
    this.bg.inputEnabled = true;
    this.bg.input.useHandCursor = true;
    this.bg.hitArea = new Phaser.Rectangle(290, 0, 80, 80);

    this.bg.events[game.device.desktop ? 'onInputDown' : 'onInputUp'].add(() => {
      // sdkHandler.trigger("gameTracking", {
      //   event: "Design",
      //   dimension1: "MenuButtonPressed"
      // });

      if (windowLayer.isEmpty()) {
        this.open = !this.open;
        playSound('button_click');
      }
    });

    const offset = -60

    const buttons = [
      this.makeTextButton(200, 200 + offset, game.getText(1), () => {
        windowLayer.pushWindow(() => new PopupHelp());
        // G.sb('pushWindow').dispatch('help');
        this.open = false;
        // sdkHandler.trigger("gameTracking", {
        //   event: "Design",
        //   dimension1: "HelpButtonPressed"
        // });
      }),

      makeImage(200, 240 + offset, 'settings_line_pixel', [0.5, 0]),

      this.makeTextButton(200, 275 + offset, game.getText(2), () => {
        windowLayer.pushWindow(() => new PopupSetup());
        this.open = false;

        // sdkHandler.trigger("gameTracking", {
        //   event: "Design",
        //   dimension1: "SetupButtonPressed"
        // });
      }),

      makeImage(200, 315 + offset, 'settings_line_pixel', [0.5, 0]),

      // this.makeTextButton(200, 350 + offset, game.getText(34), () => {
      //     // G.sb('pushWindow').dispatch('backToMainMenu');
      //     this.open = false;

      //     // sdkHandler.trigger("gameTracking", {
      //     //     event: "Design",
      //     //     dimension1: "MenuButtonPressed"
      //     // });
      //   }),
    ];

    if (!desktop) buttons.forEach((c) => c.y *= -1);

    this.addMultiple(buttons);
  }

  public update(): void {
    if (this.desktop) {
      this.y = lerp(this.y, this.open ? -438 : -80, 0.1, 1);
    } else {
      this.y = lerp(this.y, this.open ? 230 : -10, 0.1, 1);
    }
  }

  private makeTextButton(x: number, y: number, label: string, callback: () => void): OneLineText | Phaser.Text {
    const btn = createOneLineText(x, y, 'font', label, 35, 370, 0.5, 0.5);
    btn.hitArea = new Phaser.Rectangle(-180, btn.height * -0.5, 360, btn.height);
    btn.inputEnabled = true;
    btn.input.useHandCursor = true;
    btn.events.onInputDown.add(callback);
    return btn;
  }
}
